import React from 'react'
import { ReactComponent as TeamSVG } from '../../../assets/images/no-inventory.svg'

interface TeamProps extends React.SVGProps<SVGSVGElement> {
  clothesColor: string
  skinColor: string
  redPuzzleColor: string
}

const InventoryIllustration: React.FC<TeamProps> = ({
  clothesColor,
  skinColor,
  redPuzzleColor,
  ...props
}) => {
  // Function to set the fill color of specific paths representing clothes
  const customizeClothesColor = (svg: React.ReactNode) => {
    return React.cloneElement(svg as React.ReactElement, {
      style: {
        '--clothes-color': clothesColor,
        '--skin-color': skinColor,
        '--red-puzzle-color': redPuzzleColor,
      } as React.CSSProperties,
    })
  }

  return customizeClothesColor(<TeamSVG {...props} />)
}

export default InventoryIllustration
